<a [storyblokLink]="link" [appStoryblok]="_editable">
  {{ text }}
  <svg
    *ngIf="caret"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      opacity="0.9"
      d="M5.28362 2.72654L10.2631 7.75654C10.3241 7.80907 10.3241 7.86154 10.2631 7.95607L5.27344 12.9756"
      stroke="#102772"
      stroke-width="1.33333"
      stroke-linecap="square"
    />
  </svg>
</a>
